module.exports = __webpack_public_path__ + "static/media/ps1.3644a398.jpg";